module.exports={account_link_complete_message:"لقد اكتمل ربط حساب Nexon."};